// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1___daf7487cb01bdc915a6{/*!*/}.FocusedNav-cls2__cf51bf80439fb3f2ebfd{box-shadow:0px -2px 4px 0px #00000014;position:fixed;bottom:0;left:0;width:100vw;background:#fff;flex:1 1 auto;display:flex;justify-content:space-evenly}@media(max-width: 300px){.FocusedNav-cls2__cf51bf80439fb3f2ebfd>*:nth-child(3){display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1___daf7487cb01bdc915a6",
	"cls2": "FocusedNav-cls2__cf51bf80439fb3f2ebfd FocusedNav-cls1___daf7487cb01bdc915a6"
};
export default ___CSS_LOADER_EXPORT___;
